// Simple frontend-only auth using localStorage. Backend integration can
// replace these helpers later without changing consumers.
const SESSION_KEY = "bbrg_admin_session";
const CREDS_KEY = "bbrg_admin_creds";

const DEFAULT_USERNAME = "admin";
const DEFAULT_PASSWORD = "admin";

function readCreds() {
    try {
        const raw = localStorage.getItem(CREDS_KEY);
        if (raw) return JSON.parse(raw);
    } catch (_) {
        // ignore parse errors — fall through to defaults
    }
    return { username: DEFAULT_USERNAME, password: DEFAULT_PASSWORD };
}

function writeCreds(creds) {
    localStorage.setItem(CREDS_KEY, JSON.stringify(creds));
}

export function login(username, password) {
    const creds = readCreds();
    if (username === creds.username && password === creds.password) {
        const session = {
            username,
            loggedInAt: new Date().toISOString(),
        };
        localStorage.setItem(SESSION_KEY, JSON.stringify(session));
        return { ok: true };
    }
    return { ok: false, error: "Invalid username or password." };
}

export function logout() {
    localStorage.removeItem(SESSION_KEY);
}

export function getSession() {
    try {
        const raw = localStorage.getItem(SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
}

export function isAuthenticated() {
    return Boolean(getSession());
}

export function changePassword(currentPassword, newPassword) {
    const creds = readCreds();
    if (currentPassword !== creds.password) {
        return { ok: false, error: "Current password is incorrect." };
    }
    if (!newPassword || newPassword.length < 4) {
        return {
            ok: false,
            error: "New password must be at least 4 characters long.",
        };
    }
    writeCreds({ ...creds, password: newPassword });
    return { ok: true };
}
